const round = (value, decimalPlaces) => {
    if (!isNaN(value)) {
        return Math.round((value + Number.EPSILON) * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
    }

    throw "Value is not a number.";
}

export {
    round
}